import React from 'react'
import { Button } from '@mui/material';

export default function ButtonKml(props) {

    const { sx, text, size, color, variant, onClick, ...other } = props

    return (
        <Button
            sx={sx}
            onClick={onClick}
            variant={variant}
            color={color}
            {...other}
            >
            {text}
        </Button>
    )
}
